import { FC } from 'react';
import ZooplaLogoAnimatedGif from './z-logo-animated.gif';

type ZooplaAnimatedLogoProps = Omit<
    JSX.IntrinsicElements['img'],
    'src' | 'width' | 'height'
>;

const ZooplaAnimatedLogo: FC<ZooplaAnimatedLogoProps> = (props) => {
    return (
        <img
            src={ZooplaLogoAnimatedGif}
            width={53}
            height={65}
            alt=""
            {...props}
        />
    );
};

export default ZooplaAnimatedLogo;
